// Job 48: the bill period could only be corrected from the Bill Runs usage form,
// not from the Invoices tab where the invoice was uploaded — so a wrong period
// meant deleting the invoice and uploading it again.
//
// The rule lives here so the service and the dialog cannot disagree about what a
// valid period is: the dialog disables Save on exactly what the service refuses.

/** Error message for an invalid period, or null when it is usable. */
export const validateBillPeriod = (
  billFrom: string | null | undefined,
  billTo: string | null | undefined,
): string | null => {
  const from = (billFrom ?? '').trim();
  const to = (billTo ?? '').trim();

  if (!from) return 'Period start date is required';
  if (!to) return 'Period end date is required';
  // ISO dates (YYYY-MM-DD) compare correctly as strings, which is how the rest of
  // the bill screens already compare them.
  if (from >= to) return 'Period start must be before the period end';
  return null;
};
